import { render, staticRenderFns } from "./MyntChangePws.vue?vue&type=template&id=dd81e886"
import script from "./MyntChangePws.vue?vue&type=script&lang=js"
export * from "./MyntChangePws.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports